import React, { memo, ReactElement } from 'react';
import { DataListControl } from 'reactApp/ui/DataListControl/DataListControl';
import { Hint } from 'reactApp/ui/Hint/Hint';

import styles from '../DataListItemRow.css';
import { BasicProps } from '../DataListItemRow.types';
import { EViewMode } from 'reactApp/modules/settings/settings.types';

export const Checkbox = memo(
    ({
        onCheckboxClick,
        isSelected,
        isDisabled,
        isLarge,
    }: {
        onCheckboxClick: BasicProps['onCheckboxClick'];
        isSelected: boolean;
        isDisabled?: boolean;
        isLarge?: boolean;
    }): ReactElement => {
        const textIsSelected = isSelected ? 'Снять выделение' : 'Выделить';
        const hint = !isDisabled ? textIsSelected : '';

        return (
            <Hint text={hint}>
                <div className={styles.check} onClick={onCheckboxClick}>
                    <DataListControl
                        type="check"
                        active={isSelected}
                        disabled={isDisabled}
                        size={isLarge ? 28 : 24}
                        viewType={EViewMode.list}
                    />
                </div>
            </Hint>
        );
    }
);

Checkbox.displayName = 'Checkbox';
